import { useCallback } from 'react';

import { useLastInteractedStoreMachine } from './useLastInteractedStoreMachine';

/**
 * Returns a helper that resets the last interacted menu store
 */
export const useResetLastInteractedMenuStore = () => {
  const { send } = useLastInteractedStoreMachine();

  return useCallback(() => {
    send({ type: 'RESET_LAST_INTERACTED_MENU_STORE' });
  }, [send]);
};
